import { render } from "./ConnectSupplierIntegrationDialog.vue?vue&type=template&id=70df1f70"
import script from "./ConnectSupplierIntegrationDialog.vue?vue&type=script&lang=js"
export * from "./ConnectSupplierIntegrationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__